<template>
    <div id="login">
        <div class="loginContainer">
            <form class="loginForm" @submit.prevent="loginForm_Submit">
                <div class="form-group row">
                    <div>
                        <label class="text-left title" style="padding-left:-150px;">欢迎登录培训管理平台</label>
                    </div> 
                </div>
                <div class="form-group row ">
                    <label for="inputEmployeeId" class="col-form-label text-right" style="margin-top:3px; padding-right:1px; ">用户编号:</label>
                    <div class="col-sm-2">
                        <input type="text" class="form-control inputStyle" id="inputEmployeeId" :placeholder="currentUserType.param2" v-model="loginInfo.userName"
                               autofocus>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputPassword" class="col-form-label text-right" style="margin-top:5px;padding-right:1px;">登录密码:</label>
                    <div class="col-sm-2">
                        <input type="password" class="form-control inputStyle" id="inputPassword" placeholder="请输入登录密码" v-model="loginInfo.password">
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputUserType" class="col-form-label text-right" style="margin-top:3px;padding-right:1px;">用户类型:</label>
                    <div class="col-sm-2">
                        <select class="select form-control inputStyle" id="inputUserType" v-model="loginInfo.userType">
                            <option v-for="code in loginUserTypeEnum" :key="code.codeValue" :value="code.codeValue">{{code.codeContent}}</option>
                        </select>
                    </div>
                </div>
                <div class="form-group row">
                    <div>
                        <button type="submit" class=" btn btn-primary  buttonStyle">登录</button>
                    </div>
                </div>
                <div class="form-group row">
                    <div >
                        <router-link to="/regist" class="routerLink">教师注册</router-link>
                        <span>{{ '如忘记密码请联系院校管理员' }}</span>
                        <!-- <router-link to="/forget" style="">忘记密码</router-link> -->
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import baseApi from "@/utils/api/base";
import userApi from "@/utils/api/user";
import url from "@/utils/api/url";
import dictionaryData from "@/utils/dictionary";
export default {
    name: "Login",
    data: function () {
        let userType = localStorage.getItem("userType");
        if (!userType) {
            userType = 1;
        }
        else {
            userType = Number(userType)
        }

        return {
            URL_UPLOAD: url.URL_UPLOAD,

            loginUserTypeEnum: [],
            currentUserType: {},

            loginInfo: {
                userName: '',
                password: '',
                userType: userType,
            }
        }
    },
    mounted() {
        this.getLoginUserTypeEnum();
    },
    methods: {
        getLoginUserTypeEnum() {
            baseApi.codeValue.getUserRuleTypeEnum().then(res => {
                this.loginUserTypeEnum = res.data;
                this.currentUserType = this.loginUserTypeEnum[0];
            });
        },

        loginForm_Submit() {
            localStorage.setItem("userType", this.loginInfo.userType);

            userApi.login.userLogin(this.loginInfo).then(res => {
                if (res.data.state) {
                    var userId = res.data.userId
                    var searchChar = '-';
                    var firstIndex = userId.indexOf(searchChar);
                    var secondIndex = userId.indexOf(searchChar, firstIndex + 1);
                    var type = userId.substring(secondIndex-4,secondIndex)
                    var realUserId = userId.substring(0,secondIndex-4) + userId.substring(secondIndex)
                    // 登录成功
                    let info = {
                        userInfo: {
                            userId: realUserId,
                            userName: res.data.userName,
                            userType: res.data.userType,
                            state: res.data.userState,
                        },
                        userType: res.data.userType,
                    };

                    this.$store.dispatch('loginAction', info);

                    switch (type) {
                        case dictionaryData.tempType.ADMIN:
                            this.$router.push('/admin');
                            break;
                        case dictionaryData.tempType.ORGAN:
                            this.$router.push('/organ');
                            break;
                        case dictionaryData.tempType.COLLEGE:
                            this.$router.push('/college');
                            break;
                        case dictionaryData.tempType.STUDENT:
                            this.$router.push('/student');
                            break;
                        case dictionaryData.tempType.EXPERT:
                            this.$router.push('/expert');
                            break;
                    }
                }
                else {
                    alert('登录失败，请重试或联系管理员！');
                }
            });
        }
    }
}
</script>

<style scoped>
 .title {
     /* margin-left: 70px; */
     font-size: 26px;
     font-weight: bold;
     color: #353C66;  
 }
 .inputStyle {
    border: none;
    width: 248px;
    height: 40px;
    background: #F7F7F7;
    border-radius: 20px;
    text-indent:24px
  }

  .buttonStyle {
   width: 321px;
    height: 40px;
    background: linear-gradient(270deg, #095CFF 0%, #68A9FD 100%);
    border-radius: 20px;
  }
  .routerLink {
      margin-right: 205px;
  }

</style>
